import {
  CheckoutCardConfig,
  CheckoutCardProvider,
} from '@checkout/util-models';

export const worldpayConfigFactory = (
  checkoutCardConfig?: CheckoutCardConfig
): CheckoutCardConfig | undefined =>
  checkoutCardConfig?.provider === CheckoutCardProvider.Worldpay
    ? checkoutCardConfig
    : undefined;
